module.exports = 'M12.242 6.197v4.406H9v5.388h3.242V32h6.66V15.99h4.47s.418-2.582.62-5.407h-5.065V6.9c0-.55.727-1.291 1.444-1.291H24V0h-4.934c-6.988 0-6.824 5.392-6.824 6.197'



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Icon/paths/facebook.js